import { BikeSpec } from './types';

/** Yamaha YZ250F (2024). Yamaha spec sheet: 250 cc 4T, 5 speed, 106 kg wet (about 99 kg dry). */
export const YZ250F: BikeSpec = {
  id: 'yz250f', brand: 'Yamaha', name: 'YZ250F', year: 2024, kind: 'mx', stroke: '4T', displacement: 250,
  dryMass: 99, peakPower: 29, peakPowerRpm: 13500, peakTorque: 27, peakTorqueRpm: 10500, limiterRpm: 14000, idleRpm: 2000,
  torqueCurve: [[2000, 0.45], [5000, 0.68], [8000, 0.88], [10500, 1], [13500, 0.76], [14000, 0.7]],
  primary: 57 / 17, gearbox: [30 / 14, 28 / 16, 29 / 20, 27 / 22, 23 / 22], finalDrive: 48 / 13,
  travelFront: 310, travelRear: 317, seatHeight: 970, wheelbase: 1475,
  level: 'beginner', discipline: 'track', livery: 'yamaha',
  model: { file: 'fleet/yz250f.glb', base: 'Yamaha YZ450F 2022', approximate: true },
  audio: { set: '4t', pitch: 1.08 },
  estimated: ['dryMass', 'peakPower', 'peakTorque', 'limiterRpm', 'torqueCurve'],
};
